<template>
    <div class="pane-template" v-if="tools.currentPaneKey === 'instance'">
        <pane-header
            :title="instance.title"
            :subtitle="instance.sub"
            :tools="tools"
            v-if="!hideHeader"
            :appIconKey="instance.type"
            :hasCloseIcon="true"
        />
        <ui-scrollable-container>
            <pane-content>
                <ui-details cover="cover" :title="instance.name" :list="[
                    {
                        label: 'Standard Identifiers',
                        value: instance.identifiers,
                    },

                    {
                        label: 'Source',
                        value: instance.source,
                    },
                    {
                        label: 'Subject(s)',
                        value: instance.subjects,
                    },
                    {
                        label: 'Edition',
                        value: instance.edition,
                    },
                    {
                        label: 'Publisher',
                        value: instance.publisher,
                    },
                    {
                        label: 'Publication date',
                        value: instance.publication_date,
                    },
                    {
                        label: 'Resource type',
                        value: instance.resource_type,
                    },
                ]"></ui-details>
                <pane-section title="Related packages" :itemCount="instance.packageCount" preset="package" :tools="tools" />
                <pane-section title="Related orders" v-if="false" preset="order" :tools="tools" />
                <pane-section title="Related items" preset="item" :tools="tools" />
            </pane-content>
        </ui-scrollable-container>
    </div>
</template>

<script>
    export default {
        name: 'pane-instance-template',
        props: ['tools', 'hideHeader'],
        computed: {
            instance() {
                return this.tools.currentView.data.pane;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// InstancePaneTemplate.vue?055b8f07